import React, { ButtonHTMLAttributes } from "react";
// import twFocusClass from "utils/twFocusClass";
import { Link } from "react-router-dom";

export interface ButtonSquareProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  size?: string;
  href: string;
}

const ButtonSquareFullRef: React.FC<ButtonSquareProps> = ({
  className = " ",
  size = "",
  href = "/listing-stay-map",
}) => {
  return (
    <Link
      to={href}
      type="button"
      className={
        ` flex items-center justify-center rounded-md  ${className} ${size} ` }
      >
        Search
      </Link>

  );
};

export default ButtonSquareFullRef;